import CodeBlock from './components/CodeBlock';
import tools from '../../tools';
import type { EditorPlugin } from '../../types/aha-editor';

const CodeBlockComponentPlugin: EditorPlugin = {
  name: 'Code Block Component Plugin',
  components: [
    {
      type: 'code',
      component: CodeBlock,
      toolbarItems: [
        [tools.ToolIndentCode, tools.ToolOutdentCode],
        [tools.ToolChooseCodeLanguage],
        [tools.ToolDelete],
      ],
    },
  ],
};

export default CodeBlockComponentPlugin;
